export const defaultContent = {
  topics: [{},{}]
}

export const detailsLayoutOptions = [
  {
    value: 'two-col',
    label: "Side-by-side"
  },
  {
    value: 'top-span',
    label: "Stacked"
  },
  {
    value: 'image',
    label: "Image"
  }
];

export const topicLayoutOptions = [
  {
    value: 'default',
    label: "Side-by-side"
  },
  {
    value: 'stacked',
    label: "Stacked"
  }
];

export const themeColors = [
  {
    hex: '#F65F5B',
    name: 'red',
    label: 'Red'
  },
  {
    hex: '#FFA65D',
    name: 'orange',
    label: 'Orange'
  },
  {
    hex: '#FFBD39',
    name: 'yellow',
    label: 'Yellow'
  },
  {
    hex: '#B0C30C',
    name: 'green',
    label: 'Green'
  },
  {
    hex: '#00B8A9',
    name: 'teal',
    label: 'Teal'
  },
  {
    hex: '#2DBDE5',
    name: 'blue',
    label: 'Blue'
  },
  {
    hex: '#7F8BDC',
    name: 'purple',
    label: 'Purple'
  }
];